import { useState } from 'react';
import moment from 'moment';

export interface DateRange {
  startDate: string;
  endDate: string;
}

/**
 * Estado del rango de fechas compartido por todas las secciones de
 * "Tendencias" del dashboard de analytics. Default: últimos 30 días, igual
 * que el dashboard actual (/admin/home) cuando no se pasa un filtro.
 */
export function useDateRange(): {
  range: DateRange;
  setRange: (range: DateRange) => void;
} {
  const [range, setRange] = useState<DateRange>({
    startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  });

  return { range, setRange };
}
